export const PHP_MAX_INTEGER_LIMIT = 9223372036854776000;
